import { render, staticRenderFns } from "./WorkshopFilter.vue?vue&type=template&id=7a23d2e0&scoped=true&"
import script from "./WorkshopFilter.vue?vue&type=script&lang=js&"
export * from "./WorkshopFilter.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopFilter.vue?vue&type=style&index=0&id=7a23d2e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23d2e0",
  null
  
)

export default component.exports